var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import Vue from "vue";
import { Component } from "vue-property-decorator";
import Login from "./components/auth/Login.vue";
import Logout from "./components/auth/Logout.vue";
import Navigation from "./components/navigation/Navigation.vue";
let App = class App extends Vue {
    constructor() {
        super();
        if (this.$store.state.user != null) {
            this.$router.push('/login');
        }
    }
    drawer = false;
    url = "http://auftrag.techno-metall.de/images/Techno-Metall-Gruppe.png";
    show = false;
    switcher() {
        if (!this.$vuetify.theme.dark) {
            this.url = "http://auftrag.techno-metall.de/images/Techno-Metall-Gruppe-dark.png";
            return this.$vuetify.theme.dark = true;
        }
        else {
            this.url = "http://auftrag.techno-metall.de/images/Techno-Metall-Gruppe.png";
            return this.$vuetify.theme.dark = false;
        }
    }
    mounted() {
        this.$store.commit('user');
    }
};
App = __decorate([
    Component({
        name: 'App',
        components: { Navigation, Login, Logout }
    }),
    __metadata("design:paramtypes", [])
], App);
export default App;
